module.exports = __webpack_public_path__ + "img/new-group-logo.384938c0.svg";